import React from 'react'
import { navigate } from '@reach/router';

import Layout from '../components/layout'

import Header from '../components/Header'
import Main from '../components/Main'
import Footer from '../components/Footer'

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    
    // const disable_animation = this.props.location.state.disable_animation || false;
    const disable_animation = this.props.location.state && 'disable_animation' in this.props.location.state ? this.props.location.state.disable_animation : false;
    const loading_state = disable_animation ? '' : 'is-loading';

    this.state = {
      isArticleVisible: false,
      timeout: false,
      articleTimeout: false,
      article: '',
      // loading: 'is-loading'
      loading: loading_state
    }
    this.handleOpenArticle = this.handleOpenArticle.bind(this)
    this.handleCloseArticle = this.handleCloseArticle.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.MainRef = React.createRef();
  }

  componentDidMount () {
    // const disable_animation = this.props.location.state.disable_animation || false;
    const disable_animation = this.props.location.state && 'disable_animation' in this.props.location.state ? this.props.location.state.disable_animation : false
    if (disable_animation) {
      this.setState({
        loading: '',
      });
    } else {
      this.timeoutId = setTimeout(() => {
          this.setState({loading: ''});
      }, 100);
    }
    document.addEventListener('mousedown', this.handleClickOutside);

    if (this.props.location.state && this.props.location.state.section) {
      this.handleOpenArticle(this.props.location.state.section, disable_animation);
    }
  }

  componentWillUnmount () {
    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleOpenArticle(article, disable_animation = false) {

    this.setState({
      isArticleVisible: !this.state.isArticleVisible,
      article
    })

    if (disable_animation) {
      this.setState({
        timeout: true,
        articleTimeout: true
      })
    } else {
      setTimeout(() => {
        this.setState({
          timeout: !this.state.timeout
        })
      }, 325)

      setTimeout(() => {
        this.setState({
          articleTimeout: !this.state.articleTimeout
        })
      }, 350)
    }

    navigate('/', { 
      state: {section: article},
      replace: true 
    })

    // if (window.gtag) {
    //   window.gtag('event', 'page_view', {
    //     page_location: 'https://mcrescas.github.io/' + article,
    //     page_path: '/' + article,
    //     page_title: article.charAt(0).toUpperCase() + article.slice(1)
    //   });
    // }
  }

  handleCloseArticle() {

    this.setState({
      articleTimeout: !this.state.articleTimeout
    })

    setTimeout(() => {
      this.setState({
        timeout: !this.state.timeout
      })
    }, 325)

    setTimeout(() => {
      this.setState({
        isArticleVisible: !this.state.isArticleVisible,
        article: ''
      })
    }, 350)
    
    navigate('/', { 
      state: {},
      replace: true 
    })

  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.MainRef.current.contains(event.target)) {
      if (this.state.isArticleVisible) {
        this.handleCloseArticle();
      }
    }
  }

  render() {
    return (
      <div ref={this.MainRef}>
      <Layout location={this.props.location}>
        <div className={`body ${this.state.loading} ${this.state.isArticleVisible ? 'is-article-visible' : ''}`}>
          <div id="wrapper">
            <Header onOpenArticle={this.handleOpenArticle} timeout={this.state.timeout} />
            <Main
              isArticleVisible={this.state.isArticleVisible}
              timeout={this.state.timeout}
              articleTimeout={this.state.articleTimeout}
              article={this.state.article}
              onCloseArticle={this.handleCloseArticle}
              setWrapperRef={this.setWrapperRef}
            />
            <Footer timeout={this.state.timeout} />
          </div>
          <div id="bg"></div>
        </div>
      </Layout>
      </div>
    )
  }
}

export default IndexPage
